import { InformationCircleIcon } from '@heroicons/react/24/outline';

import { Input } from '@/components/form/Input';
import { Tooltip } from '@/components/Tooltip';
import { Container } from '@/components/ui';
import { SUBSCRIPTION_INPUT_CLASS } from '@/sections/settings/subscription/constant';
import { SubscriptionConfiguration } from '@/types';
import { cn } from '@/utils/classname';

export interface MSRPPriceSectionProps {
  localSubscription: SubscriptionConfiguration;
  onAssetChange: (value: number) => void;
  onAppChange: (value: number) => void;
  msrp: number;
  floor: number;
}

export function MSRPPriceSection({
  localSubscription,
  onAssetChange,
  onAppChange,
  msrp,
  floor,
}: MSRPPriceSectionProps) {
  return (
    <section className="space-y-4">
      <h3 className="text-chariot-text-primary text-base font-semibold">
        MSRP Price
      </h3>
      <Container className="bg-chariot-background-primary">
        {/* Coverage Limits */}
        <div className="mb-4 space-y-3">
          <div className="flex items-center justify-between">
            <label className="text-chariot-text-primary text-sm">
              Asset Coverage Limit
            </label>
            <Input
              name="numberOfAssets"
              value={localSubscription.numberOfAssets.toString()}
              onChange={e => {
                onAssetChange(parseInt(e.target.value) || 0);
              }}
              className={cn(SUBSCRIPTION_INPUT_CLASS, 'w-32 text-right')}
              placeholder="Enter limit"
            />
          </div>

          <div className="flex items-center justify-between">
            <label className="text-chariot-text-primary text-sm">
              Application Coverage Limit
            </label>
            <Input
              name="numberOfApplications"
              value={localSubscription.numberOfApplications.toString()}
              disabled={!localSubscription.attackSurface.applications}
              onChange={e => {
                onAppChange(parseInt(e.target.value) || 0);
              }}
              className={cn(SUBSCRIPTION_INPUT_CLASS, 'w-32 text-right')}
              placeholder="Enter limit"
            />
          </div>
        </div>

        {/* MSRP Price Display */}
        <div className="border-chariot-stroke flex items-center justify-between border-t pt-4">
          <p className="text-chariot-text-tertiary flex items-center gap-2 text-xs font-semibold tracking-wide uppercase">
            MSRP Price
            <Tooltip title="Auto-Calculated Based on Coverage Limits">
              <InformationCircleIcon className="text-chariot-text-secondary h-4 w-4" />
            </Tooltip>
          </p>
          <div className="text-chariot-text-primary text-right">
            <div className="text-2xl font-bold">${msrp.toLocaleString()}</div>
            <div className="text-chariot-text-secondary text-xs">
              Floor: ${floor.toLocaleString()}
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
